import dayjs from "dayjs";

import { OrdersAPI } from "@api-clients/orders";
import { CustomerAPI } from "@api-clients/customer";
import { OrdersState } from "libs/orders-state/src";

const OCTOBER_INDEX = 9;

export async function checkHalloweenRecipeEligibility(
  customerApi: CustomerAPI,
  ordersAPI: OrdersAPI,
  subscriptionId: number,
): Promise<boolean> {
  if (!customerApi) {
    return false;
  }

  const ordersState = new OrdersState(ordersAPI);

  const subscriptions = await customerApi.getAllSubscriptions();
  const sub = subscriptions.freshMealPlans.find((x) => x.parentId === subscriptionId);
  if (dayjs(sub?.nextDeliveryDate).month() !== OCTOBER_INDEX) {
    return false;
  }

  // Check if the user is allergic to chicken or salmon
  const cats = await customerApi.getFreshCats();
  const thisCatId = Object.keys(cats.cats).find((c) => cats.cats[c].freshMealPlanId === subscriptionId);

  if (thisCatId) {
    const totalAllergies = cats.cats[thisCatId].cat.medicalConditionsDetails?.split(",") ?? [];
    const normalisedAllergies = totalAllergies.map((a) => a.trim().toLowerCase());
    const allergicToRecipe = normalisedAllergies.some((x) => [ "chicken", "duck", "turkey" ].includes(x));
    if (allergicToRecipe) {
      return false;
    }
    const hasAlreadyHadRecipe = await ordersState.hadHalloweenRecipe(subscriptionId);
    return !hasAlreadyHadRecipe;
  }

  // Fallback to assume they won't receive it
  return false;
}
